import {Component, EventEmitter, Input, OnInit, Output} from "@angular/core";
import {CourseService} from "@app/@core/services/course.service";
import {Observable} from "rxjs";
import {SelectItemGroup} from "primeng/api";
import {map} from "rxjs/operators";
import {PackageInfoService} from "@app/@core/services/package-info.service";
import {LeisureShopService} from "@app/@core/services/leisure-shop.service";


interface KV {
  id?: string;
  name?: string;
}

@Component({
  selector: 'app-package-select',
  template: `
    <ng-container *ngIf="multi;else templateSingle">
      <p-multiSelect [options]="groupedOptions$| async"
                     [(ngModel)]="packageId"
                     [group]="true"
                     [styleClass]="styleClass"
                     (ngModelChange)="changed($event)"
                     placeholder="Select a Package"
                     selectedItemsLabel="{0} items selected">
      </p-multiSelect>
    </ng-container>

    <ng-template #templateSingle>
      <p-dropdown [options]="groupedOptions$| async"
                  [filter]="true"
                  [(ngModel)]="packageId"
                  [showClear]="true"
                  [styleClass]="styleClass"
                  (ngModelChange)="changed($event)"
                  [group]="true"
                  placeholder="Select a Package">
      </p-dropdown>
    </ng-template>

    <ng-template let-group pTemplate="group">
      <div class="text-center">
        <span class="text-primary">-- {{ group.label }} --</span>
      </div>
    </ng-template>
  `,
  styles: []
})

export class PackageSelectComponent implements OnInit {
  @Input() packageId: string | string[];
  @Input() multi = false;
  @Input() openOnly = false;
  @Input() styleClass: string;
  @Output() onChanged = new EventEmitter<KV | KV[]>();
  @Output() packageIdChange = new EventEmitter<string | string[]>();
  groupedOptions$: Observable<SelectItemGroup[]>;

  constructor(private packageInfoService: PackageInfoService,) {
  }

  ngOnInit(): void {
    if (this.openOnly) {
      this.groupedOptions$ = this.packageInfoService.groupedOptions$;
    } else {
      this.groupedOptions$ = this.packageInfoService.groupedOptions$.pipe(
        map((groupedOptions: SelectItemGroup[]) => {
          return groupedOptions.filter(groupedOption => groupedOption.label === 'ACTIVE');
        })
      );
    }
  }


  changed($event: any) {
    this.packageIdChange.emit(this.packageId);

    if (this.packageId) {
      if (Array.isArray(this.packageId)) {
        const kvs = this.packageId.map((id: string) => ({id, name: this.packageInfoService.getName(id)} as KV));
        this.onChanged.emit(kvs);
      } else {
        this.onChanged.emit({id: this.packageId, name: this.packageInfoService.getName(this.packageId)});
        this.onChanged.emit({id: this.packageId, name: this.packageInfoService.getName(this.packageId)});
      }
    } else {
      console.log('packageId3');
      this.onChanged.emit({});
    }
  }
}
